<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
@if (!isLoading) {
  <ziro-dubber-compliance-recording-form
    [fieldConfig]="fieldConfig"
    [entity]="initialEntity"
    [dubberUser]="dubberUser"
    [ms360View]="ms360View"
  ></ziro-dubber-compliance-recording-form>
}
